import { REPORT_TIER_TO_REMEDIATE_PARAM, isReportTierOptions } from '@StandingAccess/types';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import AssessmentReportRemediationModal from './AssessmentReportRemediationModal';
import useGetReport from '@StandingAccess/hooks/use-get-report';

interface AssessmentReportRemediationProps {
  reportId: string;
}

export default function AssessmentReportRemediation({ reportId }: AssessmentReportRemediationProps) {
  const { report } = useGetReport(reportId);

  const [searchParams, setSearchParams] = useSearchParams();

  const tierToRemediate = useMemo(() => {
    const tierQp = searchParams.get(REPORT_TIER_TO_REMEDIATE_PARAM);
    return tierQp && isReportTierOptions(tierQp) ? tierQp : undefined;
  }, [searchParams]);

  const onClose = () => {
    searchParams.delete(REPORT_TIER_TO_REMEDIATE_PARAM);
    setSearchParams(searchParams, { replace: true });
  };

  if (!report) return null;

  return (
    <AssessmentReportRemediationModal report={report.report} tierToRemediate={tierToRemediate} onClose={onClose} />
  );
}
